import React from 'react'
import PropTypes from 'prop-types'
import { Table } from 'reactstrap'
import styles from './TableSlatePlugin.scss'

const TableNode = ({ hasTable, actions, options, attributes, children }) => (
  <Table className={styles.Table} bordered><tbody {...attributes}>{children}</tbody></Table>
)

TableNode.propTypes = {
  hasTable: PropTypes.func,
  actions: PropTypes.object,
  options: PropTypes.object,
  attributes: PropTypes.object,
  children: PropTypes.node
}

export default TableNode



// WEBPACK FOOTER //
// ./src/components/DeepTableSlatePlugin/Table.js